import { type ActiveFeedStatus, ActiveFeedStatus as IntegrationStatus } from '../types'

export const isANeedsAttentionIntegrationStatus = ( status: ActiveFeedStatus | null | undefined ): boolean => {
	return (
		status === IntegrationStatus.ACTION_NEEDED ||
		status === IntegrationStatus.AUTH_FAILED ||
		status === IntegrationStatus.UNRESPONSIVE
	)
}
